import { render, staticRenderFns } from "./PruningCatch.vue?vue&type=template&id=7ab54a14"
import script from "./PruningCatch.vue?vue&type=script&lang=js"
export * from "./PruningCatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports